import { default as axiosService } from "axios";
import { APP_ROUTES } from "const";
import { supabase } from "lib/supabaseClient";

export const axios = axiosService.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const axiosToPdfApi = axiosService.create({
  baseURL:
    "https://we-api.weattitude.org/ocpu/library/WEapi/R/gen.handout.sheet.fun",
});

export const axiosToAIApi = axiosService.create({
  baseURL:
    process.env.REACT_APP_ANALYTICS_API_URL ?? "https://www.we-api.weattitude.org/",
});

axios.interceptors.request.use(
  async (request) => {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (token) {
      request.headers = {
        ...request.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return request;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await supabase.auth.signOut();
      window.location.assign(APP_ROUTES.ISSUES);
    }
    return Promise.reject(error);
  }
);

export default axios;
